// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "organization" + "." + "85ddc1f4" + ".chunk.css";
};